import React from "react";
import style from "./index.module.scss";
import { Button } from "antd";
import {
    filteredStuListAtom,
    paramsAtom,
    searchTextAtom,
    showModalAtom
} from "service/stores/RollCallStore";
import { useAtomValue, useSetAtom } from "jotai";
import { exportStuMark } from "service/rollCall";
import InputSearch from "components/CourseComponents/InputSearch";

export default function RollCallHeader() {
    const setSearchText = useSetAtom(searchTextAtom);
    const showModal = useSetAtom(showModalAtom);
    const stuList = useAtomValue(filteredStuListAtom);
    const { weekTimeId } = useAtomValue(paramsAtom);

    return (
        <div className={style.root}>
            <div className={style.tools}>
                <InputSearch
                    className={style.input}
                    onChange={setSearchText}
                    placeholder="请输入要搜索学生的姓名或学号"
                />
                <div className={style.spacer} />
                <Button
                    className={style.export}
                    type="primary"
                    ghost
                    onClick={() => exportStuMark(weekTimeId)}>
                    导出数据
                </Button>
                <Button
                    className={style.random}
                    type="primary"
                    onClick={() => showModal(true)}>
                    随机选人
                </Button>
            </div>

            <div className={style.count}>共 {stuList.length} 人</div>
        </div>
    );
}
